import { create } from "zustand"

const MAX_EMAIL_CACHE_SIZE = 500

interface IPeopleListStore {
  activePerson: any
  setActivePerson: (value: any) => void
  openMessageTemplate: any
  setOpenMessageTemplate: (value: any) => void
  emailsFetched: Map<string, string>
  setEmailsFetched: (key: string, value: any) => void
  clearEmailsFetched: () => void
  selectedOpportunityPerson: any
  setSelectedOpportunityPerson: (value: any) => void
  selectedOpportunityId: string
  setSelectedOpportunityId: (value: string) => void
  refetchChampions: (() => void) | null
  setRefetchChampions: (refetch: (() => void) | null) => void
}

const usePeopleListStore = create<IPeopleListStore>((set) => ({
  activePerson: null,
  setActivePerson: (value) => set({ activePerson: value }),
  openMessageTemplate: null,
  setOpenMessageTemplate: (value) => set({ openMessageTemplate: value }),
  emailsFetched: new Map(),
  setEmailsFetched: (key: string, val: any) =>
    set((store) => {
      const newMap = new Map(store.emailsFetched)
      newMap.set(key, val)
      if (newMap.size > MAX_EMAIL_CACHE_SIZE) {
        const firstKey = newMap.keys().next().value
        if (firstKey) {
          newMap.delete(firstKey)
        }
      }
      return { emailsFetched: newMap }
    }),
  clearEmailsFetched: () => set(() => ({ emailsFetched: new Map() })),
  selectedOpportunityPerson: null,
  setSelectedOpportunityPerson: (value) =>
    set({ selectedOpportunityPerson: value }),
  selectedOpportunityId: "",
  setSelectedOpportunityId: (value) => set({ selectedOpportunityId: value }),
  refetchChampions: null,
  setRefetchChampions: (refetch) => set({ refetchChampions: refetch })
}))

export default usePeopleListStore
